// App Access Token
export const APP_ACCESS_TOKEN_KEY_NAME = 'dash_aat'

// User Access Token
export const USER_ACCESS_TOKEN_KEY_NAME = 'dash_uat'
